module.exports = __webpack_public_path__ + "img/ica_peln.5e633fd1.png";